import React from "react";

export default function RequiredLabel({ children, className = "", htmlFor }) {
  return (
    <label htmlFor={htmlFor} className={`block text-sm font-medium ${className}`}>
      {children}
      <span aria-hidden="true" className="ml-0.5 text-red-600">
        *
      </span>
      <span className="sr-only"> required</span>
    </label>
  );
}
